import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthNewPasswordRoutingModule } from './auth-new-password-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { PlainToolbarModule } from '../plain-toolbar/plain-toolbar.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { AuthNewPasswordComponent } from './auth-new-password/auth-new-password.component';
import { AuthNewPasswordFormComponent } from './auth-new-password-form/auth-new-password-form.component';

@NgModule({
  declarations: [
    AuthNewPasswordComponent,
    AuthNewPasswordFormComponent
  ],
  imports: [
    CommonModule,
    AuthNewPasswordRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    PlainToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ]
})
export class AuthNewPasswordModule { }
